export function StepDescription({ children }) {
  return <p className="text-sm text-center sm:text-base text-neutral-muted-darker">{children}</p>;
}
